import jsonServerProvider from 'ra-data-json-server';
import {fetchUtils} from 'react-admin';
import {SERVER_URL} from "./utils";

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({Accept: 'application/json'});
    }
    // add your own headers here
    options.credentials = 'include';
    return fetchUtils.fetchJson(url, options);
};

const dataProvider = jsonServerProvider(SERVER_URL + '/api/v1', httpClient);

const myDataProvider = {
    ...dataProvider,
    update: async (resource, params) => {
        console.log(params.data)
        if ((resource !== 'product_type' && resource !== 'product' && resource !== "document") || (!params.data.pictures && !params.data.files)) {
            // fallback to the default implementation
            return dataProvider.update(resource, params);
        }

        let userManual, installerManual, document, newPicture;

        if (params.data.pictures) {
            newPicture = {
                src: await convertFileToBase64(params.data.pictures),
                title: params.data.pictures.title
            };
        }
        if (params.data.files?.userManual) {
            userManual = {
                src: await convertFileToBase64(params.data.files.userManual),
                title: params.data.files.userManual.title,
            }
        }
        if (params.data.files?.document) {
            document = {
                src: await convertFileToBase64(params.data.files.document),
                title: params.data.files.document.title,
            }
        }

        if (params.data.files?.installerManual) {
            installerManual = {
                src: await convertFileToBase64(params.data.files.installerManual),
                title: params.data.files.installerManual.title,
            }
        }
        return dataProvider.update(resource, {
            ...params,
            data: {
                ...params.data,
                img: newPicture !== undefined ? newPicture.src : null,
                userManual: userManual !== undefined ? userManual.src : null,
                installerManual: installerManual !== undefined ? installerManual.src : null,
                dataSheet: document !== undefined ? document.src : null
            }
        })
    },
    create: async (resource, params) => {
        console.log(params.data)
        if ((resource !== 'product_type' && resource !== 'product' && resource !== 'document') || (!params.data.pictures && !params.data.files)) {
            // fallback to the default implementation
            return dataProvider.create(resource, params);
        }

        let userManual, installerManual, document, newPicture;

        if (params.data.pictures) {
            newPicture = {
                src: await convertFileToBase64(params.data.pictures),
                title: params.data.pictures.title
            };
        }
        if (params.data.files?.userManual) {
            userManual = {
                src: await convertFileToBase64(params.data.files.userManual),
                title: params.data.files.userManual.title,
            }
        }
        if (params.data.files?.document) {
            document = {
                src: await convertFileToBase64(params.data.files.document),
                title: params.data.files.document.title,
            }
        }

        if (params.data.files?.installerManual) {
            installerManual = {
                src: await convertFileToBase64(params.data.files.installerManual),
                title: params.data.files.installerManual.title,
            }
        }
        return dataProvider.create(resource, {
            ...params,
            data: {
                ...params.data,
                img: newPicture !== undefined ? newPicture.src : null,
                userManual: userManual !== undefined ? userManual.src : null,
                installerManual: installerManual !== undefined ? installerManual.src : null,
                dataSheet: document !== undefined ? document.src : null
            }
        })
    },
    getUserProfile() {
        const profile = localStorage.getItem("userProfile");
        if (!profile) {
            return Promise.resolve({data: {}});
        }
        const data = JSON.parse(profile);
        console.log("getUserProfile", data);
        return Promise.resolve({data});
    },
    async updateUserProfile({data}) {
        // Convert a newly uploaded file to b64
        const avatar = await (data.avatar.rawFile instanceof File
            ? convertFileToBase64(data.avatar)
            : data.avatar);

        localStorage.setItem(
            "userProfile",
            JSON.stringify({
                ...data,
                id: "unique_id",
                avatar
            })
        );
        return Promise.resolve({data});
    }
};

/**
 * Convert a `File` object returned by the upload input into a base 64 string.
 * That's not the most optimized way to store images in production, but it's
 * enough to illustrate the idea of data provider decoration.
 */
export const convertFileToBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;

        reader.readAsDataURL(file.rawFile);
    });

export default myDataProvider;
